"use strict";

exports.__esModule = true;
exports.sumAlertCounts = exports.rollupCountDay = exports.getSelectedInterval = exports.getChartProps = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _Theme = require("../../../Theme");
var _libCalendar = require("@vimana/lib-calendar");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getChartProps = exports.getChartProps = function getChartProps(selectedInterval, xAxis, yAxis, tooltip) {
  return {
    selectedInterval: selectedInterval,
    xAxisProps: getXAxisProps(xAxis),
    yAxisProps: getYAxisProps(yAxis),
    tooltipProps: getTooltipProps(tooltip)
  };
};

// `day` is already a plant-local YYYY-MM-DD. Week, month, and year roll up from that calendar day.
var rollupCountDay = exports.rollupCountDay = function rollupCountDay(day, groupBy, timezone) {
  if (!groupBy || groupBy === "day") {
    return day;
  }
  var zoned = _momentTimezone["default"].tz(day, timezone);
  if (groupBy === "week") {
    return zoned.startOf("week").format("YYYY-MM-DD");
  }
  if (groupBy === "month") {
    return zoned.format("YYYY-MM");
  }
  if (groupBy === "year") {
    return zoned.format("YYYY");
  }
  return day;
};
var sumAlertCounts = exports.sumAlertCounts = function sumAlertCounts(counts, keyOf) {
  return (counts || []).reduce(function (acc, item) {
    var key = keyOf(item);
    var existing = acc.find(function (row) {
      return row.key === key;
    });
    if (existing) {
      existing.count += item.count;
      existing.rows.push(item);
    } else {
      acc.push({
        key: key,
        count: item.count,
        rows: [item]
      });
    }
    return acc;
  }, []);
};
var getSelectedInterval = exports.getSelectedInterval = function getSelectedInterval(_ref) {
  var start = _ref.start,
    end = _ref.end;
  return {
    startMillis: new Date(start).getTime(),
    endMillis: new Date(end).getTime()
  };
};
var getXAxisProps = function getXAxisProps(_ref2) {
  var selectedInterval = _ref2.selectedInterval,
    hideAxis = _ref2.hideAxis,
    timezone = _ref2.timezone;
  var domain = [selectedInterval.startMillis + (0, _libCalendar.getTimezoneOffsetMillis)(timezone.name, selectedInterval.startMillis), selectedInterval.endMillis + (0, _libCalendar.getTimezoneOffsetMillis)(timezone.name, selectedInterval.endMillis)];
  return {
    domain: domain,
    hide: hideAxis
  };
};
var getYAxisProps = function getYAxisProps(_ref3) {
  var enableYDomain = _ref3.enableYDomain,
    minYValue = _ref3.minYValue,
    maxYValue = _ref3.maxYValue,
    hideAxis = _ref3.hideAxis;
  var domain;
  if (!enableYDomain) {
    domain = ["dataMin", "dataMax"];
  } else {
    domain = [typeof minYValue !== "undefined" ? minYValue : "dataMin", typeof maxYValue !== "undefined" ? maxYValue : "dataMax"];
  }
  return {
    domain: domain,
    hide: hideAxis
  };
};
var getTooltipProps = function getTooltipProps(_ref4) {
  var yValueName = _ref4.yValueName,
    xValueFormat = _ref4.xValueFormat;
  return {
    xValueFormatter: xValueFormatter(xValueFormat),
    yValueFormatter: getYValueFormatter(yValueName)
  };
};
var xValueFormatter = function xValueFormatter(xValueFormat) {
  if (xValueFormat === void 0) {
    xValueFormat = "YYYY-MM-DD";
  }
  return function (data) {
    var _data$;
    return _momentTimezone["default"].utc((_data$ = data[0]) == null || (_data$ = _data$.payload) == null ? void 0 : _data$.key).format(xValueFormat);
  };
};
var getYValueFormatter = function getYValueFormatter(yValueName) {
  return function (data) {
    return data.reduce(function (yValues, _ref5) {
      var payload = _ref5.payload;
      return [].concat(yValues, [{
        name: yValueName,
        color: (0, _Theme.val)("DefaultChartColor"),
        value: payload == null ? void 0 : payload.value
      }]);
    }, []);
  };
};